import './css/styles.scss';

function kontaktrutaInit(): void {}

kontaktrutaInit();
